import React from "react";
import PropTypes from "prop-types";
import Button from "wonderbly-components/lib/Button";
import cx from "classnames";
import "./CallToAction.scss";

const CallToAction = (props) => {
  return (
    <section
      className={cx("call-to-action", {
        [`call-to-action--${props.ctaHorizontalAlignment}`]:
          props.ctaHorizontalAlignment,
      })}
    >
      <div className="container-guttered">
        <Button href={props.ctaLink} unstyled={props.ctaStyle === "unstyled"}>
          {props.content}
        </Button>
      </div>
    </section>
  );
};

CallToAction.propTypes = {
  content: PropTypes.string.isRequired,
  ctaLink: PropTypes.string.isRequired,
  ctaColor: PropTypes.string,
  ctaStyle: PropTypes.string,
  ctaHorizontalAlignment: PropTypes.string,
};

export default CallToAction;
